@charset "UTF-8";

/* src/app/forms/simple-datagrid/simple-datagrid.component.scss */
.simpletable {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  height: 100%;
}
.grid-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .grid-spin > .ant-spin-container {
  height: 100%;
  width: 100%;
}
:host ::ng-deep .tem-cell-loading {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid var(--tem-accent-soft);
  border-top-color: var(--tem-accent);
  border-radius: 50%;
  animation: tem-cell-spin 0.8s linear infinite;
  vertical-align: middle;
}
@keyframes tem-cell-spin {
  to {
    transform: rotate(360deg);
  }
}
.datagrid-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
  font-family: var(--tem-font-family);
}
.atualizar-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
}
.filter-select {
  width: 100%;
}
.menu-label {
  margin-left: var(--tem-space-2);
}
.mouseOut {
  display: none;
  opacity: 0;
  transition: opacity 1s ease-out;
  -webkit-animation: fade-out 1s;
  animation: fade-out 1s;
}
.mouseOver {
  visibility: visible;
  opacity: 1;
  -webkit-animation: fade-in 1s;
  animation: fade-in 1s;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
#editar.mouseOver:hover {
  color: cornflowerblue;
}
#excluir.mouseOver:hover {
  color: crimson;
}
.mainclass {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
:host ::ng-deep .simpletable .ag-theme-quartz,
:host ::ng-deep .simpletable .ag-theme-quartz-dark {
  --ag-wrapper-border-radius: 0;
}
:host ::ng-deep .simpletable .ag-theme-quartz .ag-root-wrapper,
:host ::ng-deep .simpletable .ag-theme-quartz-dark .ag-root-wrapper {
  border: none;
}
:host {
  height: 100%;
  width: 100%;
}
.filter {
  display: flex;
  width: 100%;
}
.item-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.name-reduce {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  min-width: 70px;
}
.item-filter .space {
  flex-grow: 1;
}
.item-filter .editicons {
  display: flex;
}
.atualizar {
  margin: 0 15px 0 0;
}
.main-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 4px;
}
.main-content-edit {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.toolbar-edit-mode .toolbar-edit-label {
  margin-left: 8px;
  font-size: 14px;
}
.span1 {
  margin-left: 10px;
}
.div1 {
  width: 20%;
}
.div2 {
  width: 100%;
}
.span2 {
  flex-grow: 1;
}
.spacer {
  flex-grow: 1;
}
.column-template {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.texto {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  width: 100%;
}
.fakeicon {
  width: 24px;
  height: 24px;
  display: inline-flex;
}
.data-col {
  display: flex;
  align-items: center;
}
::ng-deep .ngx-datatable .datatable-icon-skip:before {
  content: "q";
}
::ng-deep .ngx-datatable .sortable .sort-btn:before {
  font-family: data-table;
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-down:before {
  content: "f";
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-up:before {
  content: "e";
}
::ng-deep .datatable-body-row.active .datatable-row-group {
  background-color: #56f6d8 !important;
}
.server-scrolling {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.icon-filter {
  cursor: pointer;
}
.summary {
  display: flex;
  padding: 4px;
}
.totalLines {
  padding-left: 12px;
}
.alert-message {
  border-radius: 16px;
  background-color: red;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 400;
  display: flex;
  align-items: end;
}
.blinker {
  animation: blinker 3s step-start infinite;
  color: yellow;
  margin-right: 10px;
  margin-left: 10px;
}
.alert-message .message {
  font-size: 12px;
  margin-right: 10px;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.lines {
  padding-right: 12px;
}
.paginator {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  width: auto;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
}
.info {
  text-align: center;
  color: var(--tem-ink);
  font-weight: 500;
  align-self: center;
  margin-right: 6px;
}
.info.data {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  padding: 5px 10px;
  font-size: 80%;
  color: var(--tem-ink);
}
.data-info {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.cancelar {
  color: blue;
  cursor: pointer;
}
.counter {
  font-size: small;
  font-weight: 500;
}
.paginator-container {
  display: flex;
  flex-direction: column;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.floating-loading {
  z-index: 100;
  position: absolute;
  left: 10px;
  bottom: 6px;
}
/*# sourceMappingURL=simple-datagrid.component.css.map */
